import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { Table } from 'react-bootstrap';
import { flatMap, forEach } from 'lodash';
import TableUtils from '../../../../../../../utils/TableUtils';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import 'react-bootstrap-table/css/react-bootstrap-table.css';

class TableSueldosCobrados extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            data: this.processData(props.data.datos)
        };
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            data: this.processData(nextProps.data.datos)
        });
    }

    processData = (data) => {
        if (data == null)
            return null;

        let info = {};

        forEach(data, (item) => {
            if (item.periodo === null)
                return;
            let periodo = moment(item.periodo);
            let agno = periodo.year();
            let mes = periodo.month();

            if (!info[agno]) {
                info[agno] = {
                    anio: agno,
                    total: 0,
                    meses: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
                };
            }

            info[agno].meses[mes] += item.remuneracion;
            info[agno].total += item.remuneracion;
        });

        let result = flatMap(info, (x) => x);
        result.sort((a,b) => (a.anio < b.anio ) ? 1 : -1);
        return result;
    }

    expandedRow = (row) => {
        return (
            <Table striped bordered condensed fill responsive>
                <thead>
                    <tr>
                        <td>Mes</td>
                        <td>Total pagado</td>
                    </tr>
                </thead>
                <tbody>
                    {row.meses.map((item, ix) => <tr key={ix}>
                        <td>{TableUtils.monthFormat(ix)}</td>
                        <td>{this.cellARSFormat(item)}</td>
                    </tr>)}
                </tbody>
            </Table>
        );
    }

    cellARSFormat(cell){
        return TableUtils.ARSFormat(cell,false);
    }

    render() {
        return (
			<BootstrapTable data={this.state.data}
				expandableRow={() => true}
				expandComponent={this.expandedRow}
				options={TableUtils.defaultConfig()}>
				<TableHeaderColumn dataField="anio" width='30' dataFormat={TableUtils.plusButtonFormat} ></TableHeaderColumn>
				<TableHeaderColumn dataField="anio" isKey>Año</TableHeaderColumn>
				<TableHeaderColumn dataField="total" dataFormat={this.cellARSFormat}>Total cobrado</TableHeaderColumn>
			</BootstrapTable>
        );
    }
}

TableSueldosCobrados.propTypes = {
    data: PropTypes.any,
    onRequestInfo :PropTypes.func,
    hidePanels: PropTypes.any    
};
export default TableSueldosCobrados;



// WEBPACK FOOTER //
// ./src/scenes/personas/components/personas-detalle/components/panel-datos-laborales/components/TableSueldosCobrados.js